import { coerceToNonEmpty } from '../../typeguards/index.js';
import { isCommerceItem, isCommerceItemIdentifierSet, isCommerceItemImage, isCommerceOffer, isCompleteCommerceItem, } from './commerceDataTypes.js';
export function isCommerceEmbedSharedOptions(subject) {
    const options = coerceToNonEmpty(subject);
    if (options === false) {
        return false;
    }
    // @todo this is very bare boned, real validation would be good.
    return ((options.buttonTitleByIdentifier === undefined ||
        typeof options.buttonTitleByIdentifier === 'object') &&
        (options.chooseBestOffer === undefined || typeof options.chooseBestOffer === 'boolean') &&
        (options.linkWrappersByIdentifier === undefined ||
            typeof options.linkWrappersByIdentifier === 'object') &&
        (options.linkWrappers === undefined || Array.isArray(options.linkWrappers)));
}
export function isCommerceEmbedImageOverrideOptions(subject) {
    const options = coerceToNonEmpty(subject);
    if (options === false) {
        return false;
    }
    if (options.imageOverrides !== undefined && !options.imageOverrides.every(isCommerceItemImage)) {
        return false;
    }
    return true;
}
export function isBaseCommerceSingleEmbedConfig(subject) {
    const config = coerceToNonEmpty(subject);
    if (config === false) {
        return false;
    }
    if (config.item !== undefined && !isCommerceItem(config.item)) {
        return false;
    }
    return true;
}
export function isListicleItemConfig(subject) {
    const result = coerceToNonEmpty(subject);
    if (result === false) {
        return false;
    }
    if (!result.item) {
        return false;
    }
    const offers = result.item.offers ?? [];
    return (typeof result.item.title === 'string' &&
        result.item.title !== '' &&
        offers.length > 0 &&
        typeof offers[0].url === 'string' &&
        offers[0].url !== '');
}
export function isInfoblockItemConfig(subject) {
    const result = coerceToNonEmpty(subject);
    if (result === false) {
        return false;
    }
    if (!isCompleteCommerceItem(result.item)) {
        return false;
    }
    if (result.options !== undefined && !isInfoblockItemOptions(result.options)) {
        return false;
    }
    return ((result.title === undefined || typeof result.title === 'string') &&
        (result.showPrice === undefined || typeof result.showPrice === 'boolean') &&
        (result.description === undefined || typeof result.description === 'string') &&
        (result.label === undefined || typeof result.label === 'string'));
}
export function isInfoblockItemOptions(subject) {
    if (!isCommerceEmbedSharedOptions(subject)) {
        return false;
    }
    if (!isCommerceEmbedImageOverrideOptions(subject)) {
        return false;
    }
    return true;
}
export function isCtaEmbedConfig(subject) {
    if (!isBaseCommerceSingleEmbedConfig(subject)) {
        return false;
    }
    if ('link' in subject &&
        typeof subject.link !== 'string' &&
        'ctaText' in subject &&
        typeof subject.link !== 'string' &&
        'identifiers' in subject &&
        !isCommerceItemIdentifierSet(subject.identifiers) &&
        'offer' in subject &&
        !isCommerceOffer(subject.offer) &&
        'options' in subject &&
        !isCtaEmbedOptions(subject.options)) {
        return false;
    }
    return true;
}
export function isCtaEmbedOptions(subject) {
    return isCommerceEmbedSharedOptions(subject);
}
export function isLinkEmbedConfig(subject) {
    if (!isBaseCommerceSingleEmbedConfig(subject)) {
        return false;
    }
    return ((subject.options === undefined || isLinkEmbedOptions(subject.options)) &&
        (subject.offer === undefined || isCommerceOffer(subject.offer)));
}
export function isLinkEmbedOptions(subject) {
    return isCommerceEmbedSharedOptions(subject);
}
//# sourceMappingURL=embedsTypes.js.map